/* MyoNoodle landing sections (mn-*): bundle buttons, customer stories, enquiry form and mobile polish.
   Works with any number of sections on a page and re-initialises when the theme editor reloads a section. */
(function () {
  'use strict';

  var EN = /^en\b/i.test(document.documentElement.lang || '');
  var T = EN ? {
    adding: 'Adding…',
    checkout: 'Preparing checkout…',
    added: 'Added to cart.',
    cartFail: 'Could not update the cart.',
    connectFail: 'Can’t connect to the cart right now. Please try again later.',
    giftAdding: 'Adding your bundle and free gifts, please wait…',
    giftAdded: 'Added to cart. The offer is applied and your gifts are free.',
    giftConfirmFail: 'Could not confirm the free gifts.',
    giftMaybe: 'Items may already be in your cart. Please check your cart first. If the offer isn’t complete, tap “Apply gift offer”. This won’t add another bundle.',
    giftChecking: 'Checking your gifts and the offer…',
    noBundle: 'There’s no eligible bundle in your cart.',
    giftFail: 'We couldn’t complete the gift offer yet. Please check your cart and make sure the gifts show HK$0 before checking out, or contact us for help.',
    giftKept: 'Your bundle and free gifts are still in your cart, with the offer applied.',
    giftPartial: 'Your items are still in your cart. View your cart, or apply the gift offer.',
    sending: 'Sending your enquiry, please wait.',
    captcha: 'If a verification check appears, please complete it to finish sending. Please don’t submit the form more than once.',
    storyLabel: 'Shared on IG'
  } : {
    adding: '正在加入…',
    checkout: '正在準備結帳…',
    added: '已加入購物車。',
    cartFail: '未能更新購物車。',
    connectFail: '暫時未能連接購物車，請稍後再試。',
    giftAdding: '正在加入套裝及贈品，請稍候…',
    giftAdded: '已加入購物車，優惠已套用，贈品免費。',
    giftConfirmFail: '未能確認免費贈品。',
    giftMaybe: '購物車可能已加入商品。請先查看購物車；如優惠未完成，可按「套用贈品優惠」，不會再加一套商品。',
    giftChecking: '正在確認贈品及優惠…',
    noBundle: '購物車內沒有合資格套裝。',
    giftFail: '暫未能完成贈品優惠。請先查看購物車，確認贈品顯示 HK$0 後再結帳，或聯絡我們協助。',
    giftKept: '你的套裝及免費贈品仍在購物車，優惠已套用。',
    giftPartial: '購物車已保留你的商品。可查看購物車，或套用贈品優惠。',
    sending: '正在傳送查詢，請稍候。',
    captcha: '如畫面要求人機驗證，請完成驗證以繼續傳送。請勿連續重複提交。',
    storyLabel: 'IG 用家分享'
  };

  var route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function each(scope, selector, fn) {
    Array.prototype.forEach.call(scope.querySelectorAll(selector), fn);
  }
  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = 'true';
    return true;
  }
  function track(event, extra) {
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: event, support_page: window.location.pathname }, extra || {}));
  }

  /* ---------- Bundle buttons ---------- */
  function initOffers(section) {
    if (!once(section, 'mnOffersReady')) return;
    var buttons = Array.prototype.slice.call(section.querySelectorAll('.mn-purchase'));
    if (!buttons.length) return;
    var status = section.querySelector('#mn-cart-status');
    var message = section.querySelector('#mn-cart-message');
    var repair = section.querySelector('#mn-cart-repair');
    var viewCart = section.querySelector('#mn-view-cart');
    var cartUrl = route + 'cart';
    var giftId = Number(section.dataset.giftVariant || 0);
    var giftQty = Number(section.dataset.giftQty || 0);
    var code = section.dataset.discount || '';
    var expectedSaving = Number(section.dataset.giftSaving || 0);
    var giftMode = giftId > 0 && giftQty > 0 && code !== '';
    var offerIds = buttons.map(function (button) { return Number(button.dataset.variant); });
    var labels = buttons.map(function (button) { return button.querySelector('.mn-purchase-label').textContent; });
    var busy = false;
    var uncertain = false;
    if (viewCart) viewCart.href = cartUrl;

    function show(text, allowRepair) {
      if (!status || !message) return;
      message.textContent = text;
      status.hidden = false;
      if (repair) repair.hidden = !allowRepair;
    }
    function setBusy(value, active) {
      busy = value;
      buttons.forEach(function (button, index) {
        button.setAttribute('aria-disabled', String(value || uncertain));
        button.setAttribute('aria-busy', String(value && button === active));
        button.querySelector('.mn-purchase-label').textContent = value && button === active ? (button.dataset.destination === 'checkout' ? T.checkout : T.adding) : labels[index];
      });
      if (repair) repair.disabled = value;
    }
    async function request(path, body) {
      var options = { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' };
      if (body) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(body);
      }
      var response = await fetch(route + path, options);
      var data = await response.json();
      if (!response.ok) {
        var error = new Error(data.description || data.message || T.cartFail);
        error.cartRequestRejected = true;
        throw error;
      }
      return data;
    }
    function go(destination) {
      window.location.assign(destination === 'checkout' ? route + 'checkout' : cartUrl);
    }
    function isGift(item) { return Number(item.variant_id || item.id) === giftId; }
    function eligible(cart) {
      return cart.items.some(function (item) { return offerIds.indexOf(Number(item.variant_id || item.id)) !== -1 && item.quantity > 0; });
    }
    function discountAmount(item, onlyCode) {
      return (item.line_level_discount_allocations || []).reduce(function (sum, entry) {
        var title = String(entry.discount_application && entry.discount_application.title || '').toUpperCase();
        return sum + (!onlyCode || title === code.toUpperCase() ? Number(entry.amount) || 0 : 0);
      }, 0);
    }
    function existingGiftCount(cart) {
      return Math.min(giftQty, cart.items.reduce(function (sum, item) {
        if (!isGift(item)) return sum;
        if (item.properties && item.properties._mn_offer === code) return sum + item.quantity;
        var price = Number(item.original_price || item.price);
        var freeQty = price > 0 ? Math.min(item.quantity, Math.floor(discountAmount(item, true) / price)) : 0;
        if (!freeQty && Number(item.final_line_price) === 0 && price > 0) freeQty = item.quantity;
        return sum + freeQty;
      }, 0));
    }
    function validOffer(cart) {
      if (!eligible(cart)) return false;
      var qty = 0;
      var saving = 0;
      cart.items.forEach(function (item) {
        if (isGift(item)) { qty += item.quantity; saving += discountAmount(item, true); }
      });
      return qty >= giftQty && (!expectedSaving || saving === expectedSaving);
    }
    function cartLock(work) {
      if (navigator.locks && navigator.locks.request) return navigator.locks.request('myonoodle-offer-cart', work);
      return work();
    }
    async function finishOffer(destination) {
      await request('cart/update.js', { discount: code });
      var cart = await request('cart.js');
      if (!validOffer(cart)) throw new Error(T.giftConfirmFail);
      show(T.giftAdded, false);
      go(destination);
    }
    async function addSimple(button, variant) {
      setBusy(true, button);
      try {
        await request('cart/add.js', { items: [{ id: variant, quantity: 1 }] });
        show(T.added, false);
        go(button.dataset.destination);
      } catch (error) {
        show(error.cartRequestRejected ? error.message : T.connectFail, false);
      } finally {
        setBusy(false);
      }
    }
    async function addWithGifts(button, variant) {
      setBusy(true, button);
      show(T.giftAdding, false);
      var mayHaveAdded = false;
      try {
        await cartLock(async function () {
          var cart = await request('cart.js');
          var items = [{ id: variant, quantity: 1 }];
          var missing = Math.max(0, giftQty - existingGiftCount(cart));
          if (missing) items.push({ id: giftId, quantity: missing, properties: { _mn_offer: code } });
          mayHaveAdded = true;
          await request('cart/add.js', { items: items });
          await finishOffer(button.dataset.destination);
        });
      } catch (error) {
        uncertain = mayHaveAdded;
        var current = null;
        try { current = await request('cart.js'); } catch (ignored) {}
        if (mayHaveAdded) show(T.giftMaybe, !!current && eligible(current));
        else show(T.connectFail, false);
      } finally {
        setBusy(false);
      }
    }
    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        if (busy || uncertain) return;
        var variant = Number(button.dataset.variant);
        if (!variant) return;
        if (giftMode) addWithGifts(button, variant);
        else addSimple(button, variant);
      });
    });
    if (!giftMode) return;
    if (repair) {
      repair.addEventListener('click', async function () {
        if (busy) return;
        setBusy(true);
        show(T.giftChecking, false);
        try {
          await cartLock(async function () {
            var cart = await request('cart.js');
            if (!eligible(cart)) throw new Error(T.noBundle);
            var missing = Math.max(0, giftQty - existingGiftCount(cart));
            if (missing) await request('cart/add.js', { items: [{ id: giftId, quantity: missing, properties: { _mn_offer: code } }] });
            await finishOffer();
          });
        } catch (error) {
          show(T.giftFail, true);
        } finally {
          setBusy(false);
        }
      });
    }
    async function showSavedCart() {
      if (busy) return;
      try {
        var cart = await request('cart.js');
        if (busy || !eligible(cart)) return;
        if (validOffer(cart)) show(T.giftKept, false);
        else if (existingGiftCount(cart) > 0) show(T.giftPartial, true);
      } catch (ignored) {}
    }
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) { uncertain = false; setBusy(false); showSavedCart(); }
    });
    showSavedCart();
  }

  /* ---------- Customer stories ---------- */
  function initStories(section) {
    if (!once(section, 'mnStoriesReady')) return;
    var track = section.querySelector('.mn-stories-track');
    var cards = Array.prototype.slice.call(section.querySelectorAll('.mn-story-card'));
    var controls = section.querySelector('.mn-stories-controls');
    var previous = section.querySelector('.mn-stories-prev');
    var next = section.querySelector('.mn-stories-next');
    var count = section.querySelector('.mn-stories-count');
    if (!track || !cards.length || !controls || !previous || !next || !count) return;
    var mobile = window.matchMedia('(max-width: 639px)');
    var label = section.dataset.storyLabel || T.storyLabel;
    var current = 0;
    var frame = 0;
    function cardPosition(index) { return cards[index].offsetLeft - cards[0].offsetLeft; }
    function update() {
      frame = 0;
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var position = Math.max(0, track.scrollLeft);
      if (position <= 2 || maxScroll <= 2) {
        current = 0;
      } else if (position >= maxScroll - 2) {
        current = cards.length - 1;
      } else {
        current = 0;
        var smallest = Infinity;
        cards.forEach(function (card, index) {
          var distance = Math.abs(position - cardPosition(index));
          if (distance < smallest) { smallest = distance; current = index; }
        });
      }
      var value = (current + 1) + ' / ' + cards.length;
      if (count.textContent !== value) count.textContent = value;
      previous.disabled = current === 0;
      next.disabled = current === cards.length - 1;
    }
    function scheduleUpdate() { if (!frame) frame = window.requestAnimationFrame(update); }
    function move(direction) {
      var target = Math.max(0, Math.min(cards.length - 1, current + direction));
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var left = target === cards.length - 1 ? maxScroll : Math.min(cardPosition(target), maxScroll);
      track.scrollTo({ left: left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }
    function setLayout() {
      controls.hidden = !mobile.matches;
      track.tabIndex = mobile.matches ? 0 : -1;
      scheduleUpdate();
    }
    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', setLayout, { passive: true });
    if (mobile.addEventListener) mobile.addEventListener('change', setLayout);
    else if (mobile.addListener) mobile.addListener(setLayout);
    setLayout();

    var dialog = section.querySelector('#mn-story-viewer');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var viewerImage = dialog.querySelector('.mn-story-viewer-image');
    var viewerTitle = dialog.querySelector('.mn-story-viewer-title');
    var closeButton = dialog.querySelector('.mn-story-close');
    var opener = null;
    each(section, '.mn-story-photo', function (link) {
      link.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        viewerImage.src = link.href;
        viewerImage.alt = (link.querySelector('img') || {}).alt || '';
        viewerTitle.textContent = (link.dataset.storyName ? link.dataset.storyName + ' · ' : '') + (link.dataset.storyLabel || label);
        try {
          dialog.showModal();
        } catch (error) {
          return;
        }
        if (!dialog.open) return;
        opener = link;
        event.preventDefault();
        closeButton.focus({ preventScroll: true });
      });
    });
    closeButton.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', function () {
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    });
  }

  /* ---------- Enquiry form and floating WhatsApp ---------- */
  function initSupport(section) {
    if (!once(section, 'mnSupportReady')) return;
    var form = section.querySelector('#mn-support-form');
    var details = section.querySelector('#mn-support-details');
    var status = section.querySelector('#mn-support-status');
    var submitButton = section.querySelector('#mn-support-submit');
    var floating = section.querySelector('#mn-whatsapp-float');
    if (!form || !details || !status || !submitButton) return;
    var desktop = window.matchMedia('(min-width: 768px)');
    var key = 'mn-contact-v1:' + window.location.pathname;
    var ttl = 30 * 60 * 1000;
    var fields = Array.prototype.slice.call(form.querySelectorAll('input[name^="contact["]:not([type="hidden"]),select[name^="contact["],textarea[name^="contact["]'));
    var submitting = false;
    var timer;
    var raf = false;

    function readDraft() {
      try {
        var saved = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (saved && Date.now() - saved.time < ttl && Date.now() >= saved.time) return saved;
        sessionStorage.removeItem(key);
      } catch (error) {}
      return null;
    }
    function saveDraft(pending) {
      var values = {};
      fields.forEach(function (el) { values[el.name] = el.value; });
      try { sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), pending: !!pending, values: values })); } catch (error) {}
    }
    function showStatus(text, state) {
      status.textContent = text;
      status.dataset.state = state;
      status.hidden = false;
      details.open = true;
    }
    function updatePosition() {
      raf = false;
      if (!floating) return;
      var bar = document.querySelector('.mn-page .mn-mobile-bar');
      var hero = document.querySelector('.mn-page .mn-hero');
      var barRect = bar ? bar.getBoundingClientRect() : null;
      var barShown = barRect && barRect.height > 0 && getComputedStyle(bar).display !== 'none';
      var bottom = barShown ? Math.max(16, window.innerHeight - barRect.top + 16) : 24;
      document.documentElement.style.setProperty('--mn-support-bottom', bottom + 'px');
      var heroPassed = hero ? hero.getBoundingClientRect().bottom <= 0 : window.scrollY > window.innerHeight * 0.6;
      var active = document.activeElement;
      var editing = active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
      var keyboard = !desktop.matches && editing;
      var dialog = document.querySelector('.mn-page dialog[open]');
      floating.hidden = !desktop.matches || !heroPassed || keyboard || !!dialog;
    }
    function queuePosition() { if (!raf) { raf = true; window.requestAnimationFrame(updatePosition); } }

    var saved = readDraft();
    var url = new URL(window.location.href);
    var posted = url.searchParams.get('contact_posted') === 'true';
    if (posted) {
      showStatus(status.dataset.success || status.textContent, 'success');
      if (saved && saved.pending) track('mn_contact_submit_success');
      try { sessionStorage.removeItem(key); } catch (error) {}
      form.reset();
      url.searchParams.delete('contact_posted');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } else if (saved) {
      fields.forEach(function (el) { if (typeof saved.values[el.name] === 'string') el.value = saved.values[el.name]; });
      if (saved.pending) details.open = true;
    }
    details.open = details.open || desktop.matches || !status.hidden;
    form.addEventListener('input', function () { if (!submitting) saveDraft(false); });
    form.addEventListener('change', function () { if (!submitting) saveDraft(false); });
    form.addEventListener('submit', function () {
      if (submitting) return;
      submitting = true;
      submitButton.disabled = true;
      saveDraft(true);
      form.setAttribute('aria-busy', 'true');
      showStatus(T.sending, 'pending');
      timer = window.setTimeout(function () {
        submitting = false;
        submitButton.disabled = false;
        form.removeAttribute('aria-busy');
        showStatus(T.captcha, 'notice');
      }, 15000);
    });
    window.addEventListener('pageshow', function (event) {
      submitting = false;
      submitButton.disabled = false;
      form.removeAttribute('aria-busy');
      window.clearTimeout(timer);
      if (event.persisted) status.hidden = true;
      queuePosition();
    });
    each(section, '[data-mn-whatsapp]', function (link) {
      link.addEventListener('click', function () { track('mn_whatsapp_click', { support_placement: 'section' }); });
    });
    if (floating) {
      floating.addEventListener('click', function () { track('mn_whatsapp_click', { support_placement: 'floating' }); });
      if (desktop.addEventListener) desktop.addEventListener('change', queuePosition); else if (desktop.addListener) desktop.addListener(queuePosition);
      window.addEventListener('scroll', queuePosition, { passive: true });
      window.addEventListener('resize', queuePosition, { passive: true });
      document.addEventListener('focusin', queuePosition);
      document.addEventListener('focusout', queuePosition);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', queuePosition);
        window.visualViewport.addEventListener('scroll', queuePosition);
      }
      queuePosition();
    }
    var badgeSlot = section.querySelector('#mn-captcha-badge-slot');
    function placeBadge() {
      var badge = document.getElementById('shop-hcaptcha-badge-container');
      if (badge && badgeSlot && badge.parentElement !== badgeSlot) badgeSlot.appendChild(badge);
    }
    if (badgeSlot) {
      placeBadge();
      new MutationObserver(placeBadge).observe(document.body, { childList: true });
    }
  }

  /* ---------- Accordions, mobile input state and gentle reveal ---------- */
  function initDetails(scope) {
    if (mobileQuery.matches) return;
    each(scope, '.mn-page details[data-mn-desktop-open]', function (el) {
      if (once(el, 'mnOpened')) el.open = true;
    });
  }
  function inputState() {
    var el = document.activeElement;
    document.body.dataset.mnInputActive = String(mobileQuery.matches && !!el && !!el.closest && !!el.closest('.mn-page') && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName));
  }
  var revealObserver = null;
  function initReveal(scope) {
    if (!mobileQuery.matches || reducedMotion.matches || !window.IntersectionObserver || !Element.prototype.animate) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealObserver.unobserve(entry.target);
          if (reducedMotion.matches) return;
          entry.target.animate([{ opacity: 0.82, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 350, easing: 'ease-out', fill: 'none' });
        });
      }, { threshold: 0.08 });
    }
    each(scope, '.mn-page .mn-food-card, .mn-page .mn-benefit-item, .mn-page .mn-quality-item, .mn-page .mn-benefit-layout figure, .mn-page .mn-booklet-life', function (el) {
      if (once(el, 'mnRevealed')) revealObserver.observe(el);
    });
  }
  function initMobileBar(scope) {
    each(scope, '.mn-page .mn-bar-wa', function (link) {
      if (once(link, 'mnTracked')) link.addEventListener('click', function () { track('mn_whatsapp_click', { support_placement: 'mobile_bar' }); });
    });
  }

  function init(scope) {
    each(scope, '[data-mn-offers]', initOffers);
    each(scope, '[data-mn-stories]', initStories);
    each(scope, '[data-mn-support]', initSupport);
    initDetails(scope);
    initReveal(scope);
    initMobileBar(scope);
  }

  function start() {
    if (!document.querySelector('.mn-page')) return;
    init(document);
    document.addEventListener('focusin', inputState);
    document.addEventListener('focusout', function () { window.requestAnimationFrame(inputState); });
    window.addEventListener('resize', inputState, { passive: true });
    window.addEventListener('pageshow', inputState);
    inputState();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    var details = target && target.closest ? target.closest('.mn-page details') : null;
    if (target && target.tagName === 'DETAILS') details = target;
    if (details) details.open = true;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
